module.exports = __webpack_public_path__ + "04_short_gray.a3c3f985.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/04_short_gray.png
// module id = lrx/
// module chunks = 0